// extracted by mini-css-extract-plugin
module.exports = {"video":"video__styles-module--2N80R"};